import React from 'react';
import { render } from 'react-dom';

import { errorCodes, getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import BookingUpgrades from '../react/BookingUpgrades';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import ProgressBar from '../react/ProgressBar';
import { STORAGE_KEYS, getLocalStorage } from '../../util/storage';
import { DEFAULT_CRITICAL_BACKUP_CURRENCY } from '../../util/currency';

export default class BookingUpgradesRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, currentProgressBarStep, loadApi, title } = this.context.dataset;

    if (!apiUrl || !model || !loadApi || !currentProgressBarStep)
      throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    const currentCurrencyCodeAndSymbol = getLocalStorage(
      STORAGE_KEYS.currentCurrency,
      DEFAULT_CRITICAL_BACKUP_CURRENCY
    );
    const { code: currencyCode } = currentCurrencyCodeAndSymbol;

    // Get existing url search params
    const existingUrlSearchParams = new URLSearchParams(window.location.search);

    const tourId =
      existingUrlSearchParams.get('TourId') || existingUrlSearchParams.get('tourId') || '';
    const orderId =
      existingUrlSearchParams.get('OrderId') || existingUrlSearchParams.get('orderId') || '';

    const baseApiUrl = new URL(`${loadApi}/${tourId}`, window.location.origin);

    if (orderId) existingUrlSearchParams.set('orderId', orderId);
    if (currencyCode) existingUrlSearchParams.set('currency', currencyCode);

    // Apply the updated search parameters to the URL
    baseApiUrl.search = existingUrlSearchParams.toString();

    const loadApiUrl = baseApiUrl.toString();

    jsonGet(loadApiUrl, null, (response) => {
      if (response.errorCode) {
        if (response.errorCode === errorCodes.TourBookingTourHasReachedPaxCapLimit) {
          window.location.href = response.redirectUri;
        }
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        BookingUpgradesRender.renderMain(
          response,
          labels,
          apiUrl,
          title,
          currentProgressBarStep,
          tourId,
          response.orderId
        ),
        this.context
      );
    });

    return render(
      BookingUpgradesRender.renderMain(
        undefined,
        labels,
        apiUrl,
        title,
        currentProgressBarStep,
        tourId,
        orderId
      ),
      this.context
    );
  }

  static renderMain(eventOptionLoadData, labels, apiUrl, title, selectedStep, tourId, orderId) {
    return (
      <>
        <ProgressBar
          steps={eventOptionLoadData?.progressBarSteps}
          selectedStep={selectedStep}
          orderId={orderId}
        />
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {eventOptionLoadData ? (
          <BookingUpgrades
            tourId={tourId}
            orderId={orderId}
            package={eventOptionLoadData}
            labels={labels}
            apiURL={apiUrl}
            selectedStep={selectedStep}
          />
        ) : (
          <Loading />
        )}
      </>
    );
  }
}
